import { render, staticRenderFns } from "./ClassTeam.vue?vue&type=template&id=b96f7cbc&"
import script from "./ClassTeam.vue?vue&type=script&lang=js&"
export * from "./ClassTeam.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports